import config from 'config';
import { authHeader } from '../_helpers';
import userService from './user.service';

const departmentService = {
    logout,
    insert,
    getAll,
    update,
    delete: _delete
};

export default departmentService;

function logout() {
    userService.logout()
    // remove user from local storage to log user out
    // localStorage.removeItem('user');
}

async function insert(department) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ department })
    };

    return await fetch(`${config.apiUrl}/departments`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/departments`, requestOptions).then(handleResponse);
}

function update(department) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({ department })
    };

    return fetch(`${config.apiUrl}/departments/${department.DepartmentId}`, requestOptions).then(handleResponse);
}

function _delete(department) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader({ department }),
        body: JSON.stringify({ department })
    };

    return fetch(`${config.apiUrl}/departments`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}


// WEBPACK FOOTER //
// ./src/_services/department.service.js